// PROPOSITO: decirle a la alumna, siempre y sin que pregunte, si lo que registro esta a salvo.
// DEPENDENCIAS: src/store/sincronizacion.
// NO OBVIO: no aparece cuando todo esta bien y no hay nada pendiente. Una barra que siempre esta
// deja de leerse. Solo se muestra cuando hay algo que decir, y desaparece cuando ya no lo hay.

import { usarCola } from '@/store/sincronizacion'

export function BarraDeSincronizacion() {
  const enLinea = usarCola(e => e.enLinea)
  const pendientes = usarCola(e => e.pendientes)
  const sincronizando = usarCola(e => e.sincronizando)

  if (enLinea && pendientes === 0 && !sincronizando) return null

  const texto = !enLinea
    ? pendientes > 0
      ? `Sin conexión · ${String(pendientes)} por subir`
      : 'Sin conexión · lo que registres se guarda'
    : sincronizando
      ? 'Subiendo…'
      : `${String(pendientes)} por subir`

  const tono = enLinea ? 'bg-info-contenedor text-info-sobre-contenedor' : 'bg-aviso-contenedor text-aviso-sobre-contenedor'

  return (
    <div
      role="status"
      aria-live="polite"
      className={`sticky top-0 z-navegacion px-4 py-2 text-center text-sm font-medio ${tono}`}
    >
      {texto}
    </div>
  )
}
